export const LISTING_RESTORE_STORAGE_KEY = 'molwe:listing-restore';
export const LISTING_RESTORE_HISTORY_KEY = 'molweListingRestoreId';
